import { circleRenderer } from '@/utils/kaleadicalHelper';
import axios from 'axios';

export const generateAskForShape = (shapeName) => {
    const circleRendererText = circleRenderer.toString();

    const prompt = `I have a habit tracker app that renders patterns using different shapes.
    I’d like you to generate a new renderer function called ${shapeName}Renderer.
    The ${shapeName}Renderer should take the habit’s count, size, and color, and arrange multiple ${shapeName}s around a central point.
    Each ${shapeName} should have sides equal to habit.size / 20, be evenly spaced around a circle, and filled with habit.color.
    The positions of the ${shapeName}s should be calculated based on a given angle (divide 360 degrees by habit.count).
    do not give me a whole shape all connected to each other.
    Make sure the hexagons are spread out evenly and sized appropriately so that they don’t overlap.
    Here’s the existing circleRenderer function for reference: ${circleRendererText}
    Just give me the function (not an arrow function) and ensure it’s named ${shapeName}Renderer.
    The function should handle drawing multiple hexagons based on the habit.count, evenly spaced in a circular pattern.
    do not give me any new lines in it dont stick shapes together.`;

    const ask = {
        model: 'gpt-3.5-turbo',
        messages: [
            { role: 'system', content: 'You are an assistant that helps generate SVG geometry code for rendering shapes.' },
            { role: 'user', content: prompt },
        ],
        max_tokens: 700,
    };

    return ask;
};

export const extractGptContent = (content) => {
    return content;
};

export const requestShapeFromAI = async (shapeName) => {
    try {
        const ask = generateAskForShape(shapeName);

        const response = await axios.post('/api/v1/ai/chatgpt', ask);

        const data = response.data;
        const geometryCode = extractGptContent(data.choices[0].message.content);
        const geometryFunction = eval(`(${geometryCode})`);
        return geometryFunction;
    } catch (error) {
        console.error('Error fetching from OpenAI:', error);
        return null;
    }
};
